var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "b-menu",
        { attrs: { activable: false } },
        [
          _vm.$store.getters.hasAnyRole([
            "suscriptor",
            "lyris",
            "or",
            "cert-admin",
          ])
            ? _c(
                "b-menu-list",
                { attrs: { label: "Mis Certificados" } },
                [
                  _c("b-menu-item", {
                    attrs: {
                      disabled: !_vm.newRequestButtonEnable,
                      tag: "router-link",
                      to: { name: "certificadosNuevaSolicitud" },
                      exact: "",
                      label: "Generar certificado",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleClickEvent.apply(null, arguments)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: { name: "certificadosListado" },
                      exact: "",
                      label: "Certificados",
                    },
                  }),
                  _vm._v(" "),
                  _vm.$store.getters.hasAnyRole(["lyris", "or", "cert-admin"])
                    ? _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: { name: "certsTable" },
                          exact: "",
                          label: "Resumen certificados",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.hasAnyRole(["lyris", "or"])
            ? _c(
                "b-menu-list",
                { attrs: { label: "Oficial de registro" } },
                [
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: { name: "certificadosOficialRegistroListado" },
                      exact: "",
                      label: "Solicitudes y certificados",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: {
                        name: "oficialesRegistro",
                        params: { idOrganization: _vm.organizacion },
                      },
                      exact: "",
                      label: "Oficiales de registro",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.hasAnyRole(["cert-admin"])
            ? _c(
                "b-menu-list",
                { attrs: { label: "Administrador de certificados" } },
                [
                  _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: {
                        name: "certificadosAdministradorCertificadosListado",
                      },
                      exact: "",
                      label: "Administrar certificados",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }